/** Historical identifiers used only to preserve existing local state. */
export const legacy = {
  accountSource: 'porto',
  authUrlKey: 'porto.authUrl',
  connectorId: 'xyz.ithaca.porto',
  databaseName: 'porto',
  dialogQueryPrefix: 'porto.',
  headlessWebAuthnOrigin: 'https://ithaca.xyz',
  headlessWebAuthnRpId: 'ithaca.xyz',
  pingMethod: 'porto_ping',
  storageKey: 'porto.store',
  themeKey: '__porto_theme',
  webAuthnVerifiedPrefix: 'porto.webauthnVerified.',
} as const

export function storageKey(name: string) {
  if (name.startsWith('levery.')) return `porto.${name.slice('levery.'.length)}`
  if (name.startsWith('__levery_'))
    return `__porto_${name.slice('__levery_'.length)}`
  return undefined
}

export function canonicalStorageKey(name: string) {
  if (name.startsWith('porto.')) return `levery.${name.slice('porto.'.length)}`
  if (name.startsWith('__porto_'))
    return `__levery_${name.slice('__porto_'.length)}`
  return undefined
}
